import { FieldLayerWellsGroup } from '@/api/fields';

export interface FlatFieldWell {
  id: string;
  name: string;
  entry_date: string | null;
  shut_down_date: string | null;
  type: string;
  type_id: string;
  layer_id: string;
}

export function flattenFieldWells(groups: FieldLayerWellsGroup[]): FlatFieldWell[] {
  return groups.flatMap((layer) =>
    layer.types.flatMap((typeGroup) =>
      typeGroup.wells.map((well) => ({
        ...well,
        type: typeGroup.type,
        type_id: typeGroup.type_id,
        layer_id: layer.layer_id,
      }))
    )
  );
}

export function countFieldWells(groups: FieldLayerWellsGroup[]): number {
  return groups.reduce(
    (total, layer) => total + layer.types.reduce((sum, typeGroup) => sum + typeGroup.wells.length, 0),
    0
  );
}

export function countFieldWellsByType(groups: FieldLayerWellsGroup[]): Record<string, number> {
  const counts: Record<string, number> = {};
  groups.forEach((layer) => {
    layer.types.forEach((typeGroup) => {
      counts[typeGroup.type] = (counts[typeGroup.type] || 0) + typeGroup.wells.length;
    });
  });
  return counts;
}
